import type { BaseTranslation } from '../i18n-types';

export const referral = {
    title: 'Referral Program',
    menu: {
        title: 'Referral program',
        badge: 'New',
    },
    link: {
        title: 'Your referral link',
        button: 'Copy link',
        buttonCopied: 'Copied',
        toastCopied: 'Link was copied',
    },
    info: {
        title: 'How it works',
        item1: {
            title: 'Share your referral link',
            description: `Invite new people to {appName:string}. You can invite both men and women. People you invite need to sign up.`,
        },
        item2: {
            title: 'Reward from models',
            description: 'You will receive 10% of the income of each invited model. For example, if model earned $50, you’ll get $5.',
        },
        item3: {
            title: 'Reward from users',
            description: 'You will receive 10% for each purchased or renewed subscription.',
        },
        note: 'For additional details, please see Referral Program Terms section in the <a href="{linkUrl:string}" class="link {linkClass:string}" target="_blank">Terms of Service</a>.',
    },
    segment: {
        modelReferrals: 'Model referrals',
        userReferrals: 'User referrals',
    },
    totals: {
        totalReferrals: 'Total referrals',
        withSubscription: 'With subscription',
        earningReferrals: 'Earning referrals',
        totalEarned: 'Total earned',
    },
} satisfies BaseTranslation;
